import React from "react";
import createSvgIcon from "@material-ui/icons/utils/createSvgIcon";
export default createSvgIcon(
  <React.Fragment>
    <g filter="url(#filter0_d)">
      <path
        d="M10.9276 4L5 19H7.42494L8.63202 15.7857H15.368L16.5751 19H19L13.0831 4H10.9276ZM9.44034 13.6429L12.0054 6.86071L14.5704 13.6429H9.44034V13.6429Z"
        fill="white"
      />
    </g>
    <defs>
      <filter
        id="filter0_d"
        x="2"
        y="2"
        width="20"
        height="21"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy="1" />
        <feGaussianBlur stdDeviation="1.5" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow"
          result="shape"
        />
      </filter>
    </defs>
  </React.Fragment>,
  `FormatColorTextWithShadowIcon`
);
